import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

const About = () => {
  const { t } = useLang();
  const VALUES = [
    { n: "01", t: t("value1.title"), d: t("about.value1Desc") },
    { n: "02", t: t("value2.title"), d: t("about.value2Desc") },
    { n: "03", t: t("value3.title"), d: t("about.value3Desc") },
  ];
  return (
    <div data-testid="about-page" className="pt-32 pb-20">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20 items-end mb-24 md:mb-32">
          <div className="md:col-span-7">
            <p className="overline mb-4">{t("about.overline")}</p>
            <h1 className="font-display text-5xl md:text-8xl tracking-tighter text-white leading-[0.92]">
              {t("about.title1")} <br />
              <span className="italic text-[#C5A059]">{t("about.title2")}</span>
            </h1>
          </div>
          <div className="md:col-span-5">
            <p className="text-[#A1A1AA] leading-relaxed text-lg">{t("about.subtitle")}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 mb-32">
          <div className="md:col-span-6">
            <div className="aspect-[4/5] bg-[#0a0a0a] overflow-hidden">
              <img
                src="https://images.pexels.com/photos/30164278/pexels-photo-30164278.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720"
                alt="Goma, RDC"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="md:col-span-6 md:pt-16 space-y-8">
            <p className="overline">{t("about.section2Overline")}</p>
            <h2 className="font-display text-3xl md:text-5xl tracking-tighter text-white leading-tight">
              {t("about.section2Title1")} <span className="italic text-[#C5A059]">{t("about.section2Title2")}</span>
            </h2>
            <p className="text-[#A1A1AA] leading-relaxed">{t("about.section2P1")}</p>
            <p className="text-[#A1A1AA] leading-relaxed">{t("about.section2P2")}</p>
            <div className="pt-4">
              <Link to="/divisions" data-testid="about-divisions-cta" className="btn-outline">
                {t("about.section2Cta")}
              </Link>
            </div>
          </div>
        </div>

        <div className="mb-32">
          <div className="max-w-3xl mb-16">
            <p className="overline mb-4">{t("about.valuesOverline")}</p>
            <h2 className="font-display text-4xl md:text-6xl tracking-tighter text-white leading-tight">
              {t("about.valuesTitle1")} <br />
              <span className="italic text-[#C5A059]">{t("about.valuesTitle2")}</span>
            </h2>
          </div>
          <div className="space-y-0">
            {VALUES.map((v) => (
              <div
                key={v.n}
                data-testid={`about-value-${v.t.toLowerCase()}`}
                className="grid grid-cols-1 md:grid-cols-12 gap-6 py-10 border-t border-white/10 last:border-b last:border-white/10"
              >
                <div className="md:col-span-2 font-display text-5xl text-[#C5A059]">{v.n}</div>
                <div className="md:col-span-4 font-display text-3xl md:text-4xl text-white">{v.t}</div>
                <div className="md:col-span-6 text-[#A1A1AA] leading-relaxed md:pt-3">{v.d}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-[#0e0e0e] border border-[#C5A059]/20 p-10 md:p-16 text-center">
          <h2 className="font-display text-3xl md:text-5xl tracking-tighter text-white mb-6">
            {t("about.ctaTitle1")} <span className="italic text-[#C5A059]">{t("about.ctaTitle2")}</span>
          </h2>
          <Link to="/contact" data-testid="about-contact-cta" className="btn-gold">
            {t("about.ctaButton")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default About;
